import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import UpdateUserModal from "./UpdateUserModal";
import LoginModal from "./LoginModal"; // Import LoginModal component
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import axios from "axios";
import SocialMediaPopup from "./SocialMediaPopUp";

const Header = ({ setActiveCategory }) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false); // State for LoginModal visibility
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [showSocialMediaModal, setShowSocialMediaModal] = useState(false);
  const [isFirst, setIsFirst] = useState(false);
  const profileRef = useRef(null);
  const [profileImage, setProfileImage] = useState(
    localStorage.getItem("profile_image")
      ? localStorage.getItem("profile_image")
      : process.env.PUBLIC_URL + "/images/profile.png"
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userKey = localStorage.getItem("user_key");
    const username = localStorage.getItem("username");

    if (token && userKey) {
      setIsAuthenticated(true);
      if (!username) {
        setShowUpdateUserModal(true);
        setIsFirst(true);
      }
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userKey = localStorage.getItem("user_key");

    const fetchData = async () => {
      if (token && userKey) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/community-user-details`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === 200) {
            if(response.data.profile_image)
                setProfileImage(response.data.profile_image);
            localStorage.setItem("username", response.data.username);
            localStorage.setItem("profile_image", response.data.profile_image);
          } else if(response.data.status===401){
            signout();
          } else { 
            setIsAuthenticated(false);
          }
        } catch (error) {
          setIsAuthenticated(false)
        }
      }
    };

    if (isAuthenticated) {
      fetchData();
    }

    document.body.addEventListener("click", handleOutsideClick);

    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [isAuthenticated]);

  const handleUpdateUsername = (newUsername, newProfileImage) => {
    localStorage.setItem("username", newUsername);
    localStorage.setItem("profile_image", newProfileImage);
    setProfileImage(newProfileImage);
    NotificationManager.success("User updated successfully", "Success");
    // console.log("Username updated to:", newUsername);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const fetchUserPosts = () => {
    toggleDropdown();
    setActiveCategory("my-posts");
  };

  const openSocialMediaModal = () => {
    toggleDropdown();
    setShowSocialMediaModal(true);
  };

  const signout = async () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user_key");
      localStorage.removeItem("username");
      localStorage.removeItem("profile_image");
      setProfileImage("");
      setIsAuthenticated(false);
      toggleDropdown();
      window.location.reload();
    } catch (error) {
      NotificationManager.error(
        "Error signing out! Please try again!",
        "Error"
      );
      // console.error("Error signing out:", error);
    }
  };

  const handleOutsideClick = (e) => {
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setDropdownVisible(false);
    }
  };

  const handleLoginSuccess = (token, userKey, profileImage) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token);
    localStorage.setItem("user_key", userKey);
    localStorage.setItem("profile_image", profileImage);
    setProfileImage(profileImage);
    setShowLoginModal(false);
    NotificationManager.success("Logged in successfully", "Success");
  };

  return (
    <Container>
      <Content>
        <Logo>
          <a href="https://www.garbhsanskarguru.com/">
          <img src="/images/logo_only.png" alt="" width={50} height={50} />
          </a>
        </Logo>
        <Title>Garbhasanskar Guru</Title>
        {isAuthenticated ? (
          <User ref={profileRef}>
            <a onClick={toggleDropdown}>
              <img src={profileImage} alt="" />
            </a>
            {dropdownVisible && (
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setIsFirst(false);
                    setShowUpdateModal(true);
                    toggleDropdown();
                  }}
                >
                  Update Profile
                </DropdownItem>
                <DropdownSeparator />
                <DropdownItem onClick={fetchUserPosts}>My Posts</DropdownItem>
                <DropdownSeparator />
                <DropdownItem onClick={openSocialMediaModal}>Follow Us</DropdownItem>
                <DropdownSeparator />
                <DropdownItem onClick={signout}>Sign Out</DropdownItem>
              </DropdownMenu>
            )}
          </User>
        ) : (
          <LoginButton onClick={() => setShowLoginModal(true)}>
            Login
          </LoginButton>
        )}
      </Content>
      <UpdateUserModal
        show={showUpdateModal}
        onClose={() => setShowUpdateModal(false)}
        onSubmit={handleUpdateUsername}
        isFirst={isFirst}
      />
      {showLoginModal && (
        <LoginModal
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
          onOtpVerificationSuccess={() => {
            setShowUpdateUserModal(true);
            setIsFirst(true);
          }}
        />
      )}
      <UpdateUserModal
        show={showUpdateUserModal}
        onClose={() => setShowUpdateUserModal(false)}
        onSubmit={handleUpdateUsername}
        isFirst={isFirst}
      />
      {showSocialMediaModal && (
        <SocialMediaPopup
          showModal={showSocialMediaModal}
          handleCloseModal={() => setShowSocialMediaModal(false)}
        />
      )}
      <NotificationContainer />
    </Container>
  );
};

const Container = styled.div`
  background-color: #F1F1F1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1); /* Add shadow for a raised effect */
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 100%;
  max-width: 295vw;

  @media (max-width: 767px) {
    justify-content: center;
    padding: 10px;
  }
`;

const Logo = styled.span`
  font-size: 0px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 24px;
  color: #e75b82;
  flex-grow: 1;
  text-align: center;

  @media (max-width: 767px) {
    font-size: 15px;
    margin-right: 60px;
  }
`;

const User = styled.div`
  position: relative;
  a > img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }

  @media (max-width: 767px) {
    position: absolute;
    right: 10px;
  }
`;

const LoginButton = styled.button`
  text-decoration: none;
  color: #fff;
  background-color: #e75b82;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s;
  border: none;
  cursor: pointer;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1); /* Add shadow for a raised effect */

  &:hover {
    background-color: #d94c72;
  }

  @media (max-width: 767px) {
    position: absolute;
    right: 10px;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-13%);
  background: #F1F1F1; /* Adjust background color */
  border: 1px solid rgba(0, 0, 0, 0.08); /* Adjust border color */
  border-radius: 8px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1); /* Add shadow for a raised effect */
  z-index: 1000;
  width: 125px;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    right: 10px;
    top: calc(100% + 10px);
    transform: none;
    width: 100px;
  }
`;

const DropdownItem = styled.a`
  text-decoration: none;
  color: #333; /* Adjust text color */

  cursor: pointer;
  padding: 10px;
  transition: background-color 0.3s;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none; /* Remove box-shadow to maintain a flat appearance */

  &:hover {
    background-color: #e5e5e5; /* Adjust hover background color */
    color: #333; /* Adjust hover text color */
  }

  @media (max-width: 767px) {
    padding: 8px;
    font-size: 12px;
  }
`;

const DropdownSeparator = styled.div`
  height: 1px;
  background-color: rgba(0, 0, 0, 0.08); /* Adjust separator color */
`;

export default Header;
